module.exports = __webpack_public_path__ + "static/img/egc_logo_max.7355130.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/egc_logo_max.svg
// module id = /YpD
// module chunks = 0